<p>fast-quote-modal works!</p>
